module.exports = __webpack_public_path__ + "static/media/D.1ba03521.png";